import { api } from './client';

type Envelope<T> = { data: T };

export type NumberingElement =
  | { kind: 'code'; name?: string; documentType?: string; shortName: string }
  | { kind: 'sequence'; name?: string; digits: number; yearPrefix: boolean }
  // Named element with its own value list (e.g. "Company name" → İS/SG). The
  // user picks one option in the wizard; up to three list elements map onto
  // the {type}/{dept}/{form} placeholders in order of appearance.
  | { kind: 'list'; name?: string; options: Array<{ label: string; code: string }> }
  // Free-text the user types per document (e.g. another company's code "FHN").
  // Consumes a {type}/{dept}/{form} slot in order, same as a list element.
  | { kind: 'input'; name?: string; placeholder?: string };

export type NumberingScheme = {
  id: string;
  name: string;
  format: string;
  elements: NumberingElement[] | null;
  nextSeq: number;
  isDefault: boolean;
};

export const numberingSchemeApi = {
  async list(): Promise<NumberingScheme[]> {
    const { data } = await api.get<Envelope<NumberingScheme[]>>('/numbering-scheme');
    return data.data;
  },

  async create(input: {
    name: string;
    format?: string;
    elements?: NumberingElement[];
    isDefault?: boolean;
    nextSeq?: number;
  }): Promise<NumberingScheme> {
    const { data } = await api.post<Envelope<NumberingScheme>>('/numbering-scheme', input);
    return data.data;
  },

  async update(
    uuid: string,
    input: Partial<{
      name: string;
      format: string;
      elements: NumberingElement[];
      isDefault: boolean;
      nextSeq: number;
    }>,
  ): Promise<NumberingScheme> {
    const { data } = await api.patch<Envelope<NumberingScheme>>(
      `/numbering-scheme/${uuid}`,
      input,
    );
    return data.data;
  },

  async delete(uuid: string): Promise<void> {
    await api.delete(`/numbering-scheme/${uuid}`);
  },

  async preview(input: {
    format?: string;
    type?: string;
    dept?: string;
    form?: string;
    seq?: number;
  }): Promise<{ number: string }> {
    const { data } = await api.post<Envelope<{ number: string }>>(
      '/numbering-scheme/preview',
      input,
    );
    return data.data;
  },
};
